import { sendNewPortRequest } from "../GraphQL/schedules";
import { getCountryName } from "./countryList";
import { classifyScheduleTransportMode } from "./classifyScheduleTransportMode";
import { v4 as uuidv4 } from "uuid";

/**
 * @memberof module:util
 * @function
 * @name filterScheduleByCheckedInDate
 * @description It filters the schedule data to cater checked in date.
 *
 * @param {array} price - scheduleData to be filtered
 * @returns {array}
 *
 */

const filterScheduleByCheckedInDate = (scheduleData) => {
    // Calculate the date three days from today
    const today = new Date();
    const threeDaysFromToday = new Date(today);
    threeDaysFromToday.setDate(today.getDate() + 3);

    // Convert to YYYY-MM-DD format
    const threeDaysFromTodayStr = threeDaysFromToday.toISOString().split('T')[0];

    // Filter the records
    const filteredScheduleData = scheduleData.filter(record => {
      return new Date(record.etd) >= new Date(threeDaysFromTodayStr);
    });

    // console.log("********* filteredRecords by etd************",filteredScheduleData);
    return filteredScheduleData
};


export const filterScheduleByStartDate = (scheduleData) => {
//   console.log("----scheduleData-----",scheduleData)
  // Calculate the date three days from today
  const today = new Date();
  const threeDaysFromToday = new Date(today);
  threeDaysFromToday.setDate(today.getDate() + 3);

  // Convert to YYYY-MM-DD format
  const threeDaysFromTodayStr = threeDaysFromToday.toISOString().split('T')[0];

  // Filter the records
  const filteredScheduleData = scheduleData.filter(record => {
    const firstLegStartDate = record.etd;
    return new Date(firstLegStartDate) >= new Date(threeDaysFromTodayStr);
  });

  // console.log("********* filteredRecords by etd************",filteredScheduleData);
  return filteredScheduleData
  };

/**
* @memberof module:util
* @function
* @name filterScheduleByRecentEtd
* @description selecting the object with the most recent etd date for each unique voyage
*
* @param {array} price - scheduleData to be filtered
* @returns {array}
*
*/
export const filterScheduleByRecentEtd = (scheduleData) => {
  //first filter the schedules for checked-in date
  const filterdSchedules = filterScheduleByCheckedInDate(scheduleData)
  // Step 1: Create a mapping of voyages to their most recent etd
  const voyageMap = filterdSchedules.reduce((acc, record) => {
  const { voyage, etd } = record;
  
  // Initialize or update the record for this voyage
  if (!acc[voyage] || new Date(etd) < new Date(acc[voyage].etd)) {
    acc[voyage] = record;
  }
  
  return acc;
}, {});

// Step 2: Extract the most recent records
const mostRecentRecords = Object.values(voyageMap);

return mostRecentRecords;
};

/**
* @memberof module:util
* @function
* @name filterScheduleByRecentEtd
* @description filter the schedule data by created date or updated date
*
* @param {array} price - scheduleData to be filtered
* @returns {array}
*
*/
export const fetchRecentByCreatedOrUpdate = (scheduleData) =>{
  const today = new Date()
  today.setHours(0, 0, 0, 0);
  const twoDaysAgo = new Date();
  twoDaysAgo.setDate(twoDaysAgo.getDate() - 2);
  // Normalize to midnight to compare only dates
  twoDaysAgo.setHours(0, 0, 0, 0);

  const recentSchedules = scheduleData.filter(schedule => {
      const createdAt = new Date(schedule.created_at || schedule.createdAt);
      const updatedAt = new Date(schedule.updated_at || schedule.updatedAt);
      const etd = new Date(schedule.etd)
      // Normalize both dates to midnight
      createdAt.setHours(0, 0, 0, 0);
      updatedAt.setHours(0, 0, 0, 0);
      etd.setHours(0, 0, 0, 0);
      // console.log("Comparing: ", {
      //   createdAt,
      //   updatedAt,
      //   twoDaysAgo,
      //   createdAtComparison: createdAt >= twoDaysAgo,
      //   updatedAtComparison: updatedAt >= twoDaysAgo,
      //   etdComparison: etd >= today
      // });
      return (
        (createdAt >= twoDaysAgo || updatedAt >= twoDaysAgo) 
        //&& etd >= today
      );
    });
  //console.log("recentSchedules: ",recentSchedules)
  //filter by checked-in
  const filteredSchedules = filterScheduleByCheckedInDate(recentSchedules)
  //console.log("filteredSchedules by checked in date: ",filteredSchedules)
  return filteredSchedules
}

/**
* @memberof module:util
* @function
* @name filterScheduleByRecentEtd
* @description filter the schedule data by created date or updated date
*
* @param {array} price - scheduleData to be filtered
* @returns {array}
*
*/
export const isUpdateRequired = (scheduleData) =>{
//console.log("---isUpdateRequired-----",scheduleData)
  const twoDaysAgo = new Date();
  twoDaysAgo.setDate(twoDaysAgo.getDate() - 2);
  twoDaysAgo.setHours(0, 0, 0, 0);
 
  const needsUpdate = scheduleData.every(schedule => {
      const createdAt = new Date(schedule.created_at);
      const updatedAt = new Date(schedule.updated_at);

      // Normalize both dates to midnight
      createdAt.setHours(0, 0, 0, 0);
      updatedAt.setHours(0, 0, 0, 0);

      //console.log("\ncreatedAt: ", createdAt, "\nupdatedAt: ", updatedAt);

      if (createdAt >= twoDaysAgo || updatedAt >= twoDaysAgo) {
      // If either createdAt or updatedAt is within the last two days
      return false;
      } else if (createdAt < twoDaysAgo && updatedAt >= twoDaysAgo) {
      // If createdAt is before twoDaysAgo but updatedAt is within the last two days
      return false;
      } else {
      // If createdAt and updatedAt are both before twoDaysAgo
      return true;
      }
  });

  return needsUpdate
}

// //Part of Line scape API integration.
// export const calculateAveragePortTransit = (schedules) =>{
//   if(schedules && schedules.length > 0){
//     // Check if all records have non-null port_to_port_transit_time
//     const portToPortTimes = schedules.map(record => record.port_to_port_transit_time);
//     const allPortToPortTimesValid = portToPortTimes.every(time => time !== null);

//     if (allPortToPortTimesValid) {
//         const totalPortToPortTime = portToPortTimes.reduce((sum, time) => sum + time, 0);
//         return Math.round(totalPortToPortTime / portToPortTimes.length); // Return average of port_to_port_transit_time
//     }
//   }  
//   return null; // Return null if neither condition is met
// }

export const refineWeeklyRoutes = (departureFrom, routeGroupList, carrierScac) => {
    // console.log("---refineWeeklyRoutes is executing.....", //departureFrom, routeGroupList
    // );
    //console.log("---carrierScac-----", carrierScac);

    let totalWeeklySchedules = 10;
    if (carrierScac === "COSU" || carrierScac === "ONEY") {
        totalWeeklySchedules = 3;  // Adjusted to 3 routes for COSU and ONEY
    }

    // Get today's date and the date 3 days ahead
    const today = new Date();
    const minETD = new Date(today);
    minETD.setDate(today.getDate() + 3); // Set to 3 days ahead of today

    // Use the departureFrom as the reference start date for week grouping
    const startDate = new Date(departureFrom);

    // Function to compute week index (Week 1, Week 2, etc.) based on the departure date (etd)
    function getWeekKey(etd) {
        const routeDate = new Date(etd);
        const diffDays = (routeDate - startDate) / (1000 * 60 * 60 * 24);
        const weekIndex = Math.floor(diffDays / 7) + 1; // +1 to make it human-friendly (Week 1, Week 2, ...)
        return `Week ${weekIndex}`;
    }

    // Group routes by week based on the "por.etd" field
    const weeklyRoutes = {};

    if (routeGroupList) {
        //console.log("Route Group List:", routeGroupList);
        routeGroupList.route.forEach(route => {
            const etd = new Date(route.por.etd);

            // Filter out routes where ETD is less than 3 days from today
            if (etd >= minETD) {
                const weekKey = getWeekKey(route.por.etd);
                if (!weeklyRoutes[weekKey]) {
                    weeklyRoutes[weekKey] = [];
                }
                weeklyRoutes[weekKey].push(route);
            }
        });
    }

    // Now, for each week, filter routes based on the totalWeeklySchedules count
    const filteredWeeklyRoutes = {};

    for (const week in weeklyRoutes) {
        const routes = weeklyRoutes[week];
        if (routes.length > totalWeeklySchedules) {
            // Sort routes by transitTime in ascending order (lowest transit times first)
            const sortedRoutes = routes.sort((a, b) => a.transitTime - b.transitTime);
            
            // Select only the first `totalWeeklySchedules` routes
            filteredWeeklyRoutes[week] = sortedRoutes.slice(0, totalWeeklySchedules);
            //console.log(`${week}: ${routes.length} routes > ${totalWeeklySchedules}. Keeping ${totalWeeklySchedules} routes.`);
        } else {
            // No filtering needed if there are fewer or equal to `totalWeeklySchedules` routes
            filteredWeeklyRoutes[week] = routes;
            //console.log(`${week}: ${routes.length} routes, no filtering needed.`);
        }
    }
    // console.log("Filtered weekly routes:", filteredWeeklyRoutes);
    return filteredWeeklyRoutes;
}


 export function findPortId(portName, portCode, getstate) {
    // console.log("----find port ID----", getstate())
    const ports = getstate()?.route?.originPortJSON?.Ports
    // console.log("portName: ",portName,"portCode: ",portCode, "ports: ",ports);
    const port = ports.find(p => ((p?.Name)?.toLowerCase() === portName?.toLowerCase()) || p.portCode === portCode);
    //console.log("....port...",port)
    return port ? port.id : null;
  }


  export const formatDate = (dateString) => {
    // Create a Date object
    const date = new Date(dateString);
    // Extract the date part in YYYY-MM-DD format
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');

    // Format the date as YYYY-MM-DD
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate
  };

  const getVesselName = (legs, index) =>{
    let vesselName = "";
    if(legs[index]?.vessel?.name && legs[index]?.vessel?.name !== "---" && legs[index]?.vessel?.name !== "TBN"){
        vesselName = legs[index]?.vessel?.name
    }else if(legs[index-1]?.vessel?.code && legs[index-1]?.vessel?.code !== "---" && legs[index-1]?.vessel?.code !== "TBN"){
        vesselName = legs[index-1]?.vessel?.code + "-TBA"
    }else{
        vesselName = uuidv4() + "-TBA"
    }

    return vesselName
}


const getServiceName = (legs, index) =>{
    let serviceName = "";
    if(legs[index]?.service?.name && legs[index]?.service?.name !== "---" && legs[index]?.service?.name !== "TBN"){
        serviceName = legs[index]?.service?.name
    }else if(legs[index-1]?.service?.code && legs[index-1]?.service?.code !== "---" && legs[index-1]?.service?.code !== "TBN"){
        serviceName = legs[index-1]?.service?.code + "-TBA"
    }else{
        serviceName = uuidv4() + "-TBA"
    }

    return serviceName
}

const getVoyageName = (legs, index) =>{
    let voyageName = "";
    if(legs[index]?.externalVoyageNumber && legs[index]?.externalVoyageNumber !== "---" && legs[index]?.externalVoyageNumber !== "TBN"){
        voyageName = legs[index]?.externalVoyageNumber
    }else if(legs[index-1]?.externalVoyageNumber && legs[index-1]?.externalVoyageNumber !== "---" && legs[index-1]?.externalVoyageNumber !== "TBN"){
        voyageName = legs[index-1]?.externalVoyageNumber + "-TBA"
    }else{
        voyageName = uuidv4() + "-TBA"
    }
    return voyageName
}

const getNewPortId = async (portName, unlocode, getstate, dispatch) =>{
    // console.log("---getNewPortId-----", portName,unlocode)
    const country = getCountryName(unlocode)
    // console.log("--country----",country)
    try{
        const result = await sendNewPortRequest(country, portName, unlocode, getstate, dispatch)
        // console.log("result: ",result)
        if(result[0] && result[1]){
            return result[1]
        }
    }catch(error){
        console.error(error)
    }
}

//actual function
export const parseBigSchedules = async (bigScheduleData, getstate, dispatch) => {
    const departureFrom = bigScheduleData?.dataRange?.departureFrom;
    if (!bigScheduleData?.routeGroupsList?.length) return {};

    // Cache to store newly created ports
    const newPortsCache = {};
    const pendingPortRequests = {};

    // 1) Process each routeGroup in parallel
    const results = await Promise.all(
      bigScheduleData.routeGroupsList.map(async (element) => {
        if (!element?.route?.length) {
          // Return an empty object so we can merge later
          return {};
        }

        const carrierScac = element?.carrier?.scac || "UNKNOWN";

        // 2) Group the routes by week
        const refinedWeeklyRoutes = refineWeeklyRoutes(departureFrom, element, carrierScac);
        // console.log("----refinedSchedules for carrier:", carrierScac, refinedWeeklyRoutes);
        // 3) Build a local map: { "CMAU Week 1": [...], "CMAU Week 2": [...], ... }
        const carrierWeekMap = {};


        // Iterate over each "Week X" in refinedWeeklyRoutes
        for (const [weekKey, routesArray] of Object.entries(refinedWeeklyRoutes)) {
          const combinedKey = `${carrierScac} ${weekKey}`;

          // We'll parse each route in routesArray
          const schedulesForWeek = await Promise.all(
            routesArray.map(async (routeElement) => {
              // ----- Build your schedule object here -----
              const { por, fnd, carrierScac, transitTime, leg: legs = [] } = routeElement;

              const originPortId = findPortId(
                por?.location?.name,
                por?.location?.unlocode,
                getstate

              ) || getNewPortId(
                por?.location?.name,
                por?.location?.unlocode,
                getstate,
                dispatch
              );

              const destinationPortId = findPortId(
                fnd?.location?.name,
                fnd?.location?.unlocode,
                getstate

              ) || getNewPortId(
                fnd?.location?.name,
                fnd?.location?.unlocode,
                getstate,
                dispatch
              );

              let schedule = {
                originPortName: por?.location?.name || "",
                originCode: por?.location?.unlocode || "",
                originPortId,
                dischargePortName: "",
                dischargeCode: "",
                dischargeId: "",
                destinationPortName: fnd?.location?.name || "",
                destinationCode: fnd?.location?.unlocode || "",
                destinationPortId,
                carrierName: element?.carrier?.name || "",
                carrierCode: carrierScac || "",
                etd: por?.etd?.substring(0, 10) || "",
                etaPortOfDestination: fnd?.eta?.substring(0, 10) || "",
                portTransitTime: transitTime || "",
                transshipments: [],
                vesselName: "",
                service: "",
                voyage: "",
            };

            // Handle case where only one leg exists
            if (legs.length === 1) {
                const onlyLeg = legs[0];
                schedule.vesselName = getVesselName(legs, 0);
                schedule.service = getServiceName(legs, 0);
                schedule.voyage = getVoyageName(legs, 0);
            
                // You can still assign discharge info directly from toPoint
                const dischargePort = onlyLeg?.toPoint?.location;
                schedule.dischargePortName = dischargePort?.name || '';
                schedule.dischargeCode = dischargePort?.unlocode || '';
                let dischargePortId = (dischargePort?.name && dischargePort?.unlocode) && findPortId(dischargePort?.name, dischargePort?.unlocode, getstate)
                schedule.dischargeId = dischargePortId;
                schedule.destinationPortName = dischargePort?.name || '';
                schedule.destinationCode = dischargePort?.unlocode || '';
                schedule.destinationPortId = dischargePortId;
                schedule.etaPortOfDischarge = onlyLeg?.toPoint?.eta?.substring(0, 10) || '';
                schedule.transportMode = onlyLeg?.transportMode || "VESSEL"
            }
            

              // ----- Handle multi-leg logic, newPortsCache, etc. -----
              if (legs.length > 1) {
                const lastLeg = legs[legs.length - 1];
                               // console.log("---last leg-----",lastLeg)
                                let legIndex;
                                if(lastLeg.transportMode === "TRUCK" || 
                                    (lastLeg.fromPoint.location.name === lastLeg.toPoint.location.name || 
                                        lastLeg.fromPoint.location.unlocode === lastLeg.toPoint.location.unlocode))
                                {
                                    legIndex = legs.length - (lastLeg[lastLeg.length -1]?.transportMode === "RAIL" ? 3 : 2);
                                }else{
                                    legIndex = legs.length - ((lastLeg?.transportMode === "RAIL" || 
                                        lastLeg?.transportMode === "INTERMODAL" ||
                                        lastLeg?.transportMode === "MULTIMODAL")? 2 : 1);
                                }
                                //const legIndex = legs.length - (lastLeg?.transportMode === "RAIL" ? 2 : 1);
                                let transportMode = lastLeg?.transportMode;

                                if (!transportMode || transportMode === "---" //|| transportMode === "INTERMODAL
                                ) {
                                    try {
                                        transportMode = await classifyScheduleTransportMode(lastLeg);
                                    } catch {
                                        transportMode = "Unknown";
                                    }
                                }

                                // console.log("Transport Mode:", transportMode,"legIndex: ",legIndex);

                                if (transportMode === "RAIL" || transportMode === "TRUCK" || transportMode === "INTERMODAL" || transportMode === "MULTIMODAL") {
                                    const dischargePort = lastLeg?.fromPoint?.location;
                                    const dischargePortKey = `${dischargePort?.name}|${dischargePort?.unlocode}`;
                                    let dischargePortId = (dischargePort?.name && dischargePort?.unlocode) && findPortId(dischargePort?.name, dischargePort?.unlocode, getstate)
                                    //const dischargePortId = (dischargePort?.name && dischargePort?.unlocode) && (findPortId(dischargePort?.name, dischargePort?.unlocode, getstate)
                                    //|| await getNewPortId(dischargePort?.name, dischargePort?.unlocode, getstate, dispatch));

                                    if (!dischargePortId && dischargePort?.name && dischargePort?.unlocode) {
                                        if (newPortsCache[dischargePortKey]) {
                                            dischargePortId = newPortsCache[dischargePortKey]; // Use cached value if exists
                                        } else if (pendingPortRequests[dischargePortKey]) {
                                            dischargePortId = await pendingPortRequests[dischargePortKey]; // Await the pending request
                                        } else {
                                            pendingPortRequests[dischargePortKey] = getNewPortId(dischargePort?.name, dischargePort?.unlocode, getstate, dispatch);
                                            dischargePortId = await pendingPortRequests[dischargePortKey]; // Await & store the new port ID
                                            newPortsCache[dischargePortKey] = dischargePortId;
                                            delete pendingPortRequests[dischargePortKey]; // Remove pending status
                                        }
                                    }

                                    Object.assign(schedule, {
                                        dischargePortName: dischargePort?.name,
                                        dischargeCode: dischargePort?.unlocode,
                                        dischargeId: dischargePortId,
                                        etaPortOfDischarge: legs[legIndex]?.toPoint?.eta?.substring(0, 10),
                                        etdPortOfDischarge: lastLeg?.fromPoint?.etd?.substring(0, 10),
                                        vesselName: getVesselName(legs, legIndex),
                                        service: getServiceName(legs,legIndex),//legs[legIndex]?.service?.name && legs[legIndex]?.service?.name !== "---" ? legs[legIndex]?.service?.name : uuidv4() + "-TBA",
                                        voyage: getVoyageName(legs, legIndex)//legs[legIndex]?.externalVoyageNumber && legs[legIndex]?.externalVoyageNumber !== "---" ? legs[legIndex]?.externalVoyageNumber : uuidv4() + "-TBA",
                                    });

                                } else {
                                    Object.assign(schedule, {
                                        vesselName: getVesselName(legs, legIndex),//legs[legIndex]?.vessel?.name && legs[legIndex]?.vessel?.name !== "---" ? legs[legIndex]?.vessel?.name : uuidv4() + "-TBA",
                                        service: getServiceName(legs,legIndex), //legs[legIndex]?.service?.name && legs[legIndex]?.service?.name !== "---" ? legs[legIndex]?.service?.name : uuidv4() + "-TBA",
                                        voyage: getVoyageName(legs, legIndex), //legs[legIndex]?.externalVoyageNumber && legs[legIndex]?.externalVoyageNumber !== "---" ? legs[legIndex]?.externalVoyageNumber : uuidv4() + "-TBA",
                                        dischargeId: destinationPortId,
                                        etaPortOfDischarge: lastLeg?.toPoint?.eta?.substring(0, 10),
                                    });
                                }

                                // **Optimized Transshipment Mapping**
                                schedule.transshipments = (await Promise.all( legs.slice(0, legIndex).map(async (leg, i) => {
                                    const nextLeg = legs[i + 1] || {};
                                    //console.log("---next leg------",nextLeg,"\nnextLeg?.fromPoint?.etd: ",nextLeg?.fromPoint?.etd)
                                    const transshipPort = leg?.toPoint?.location;
                                    const transshipPortKey = `${transshipPort?.name}|${transshipPort?.unlocode}`;
                                    let transshipPortId = (transshipPort?.name && transshipPort?.unlocode) && (findPortId(transshipPort?.name, transshipPort?.unlocode, getstate))
                                    let transhipentMode = leg?.transportMode

                                    if (!transshipPortId && transshipPort?.name && transshipPort?.unlocode) {
                                        if (newPortsCache[transshipPortKey]) {
                                            transshipPortId = newPortsCache[transshipPortKey];
                                        } else if (pendingPortRequests[transshipPortKey]) {
                                            transshipPortId = await pendingPortRequests[transshipPortKey];
                                        } else {
                                            pendingPortRequests[transshipPortKey] = getNewPortId(transshipPort?.name, transshipPort?.unlocode, getstate, dispatch);
                                            transshipPortId = await pendingPortRequests[transshipPortKey];
                                            newPortsCache[transshipPortKey] = transshipPortId;
                                            delete pendingPortRequests[transshipPortKey];
                                        }
                                    }

                                    if (leg.transportMode === "TRUCK" && leg.fromPoint.location.name === leg.toPoint.location.name) {
                                        //console.log("---via Truck--- Leg",leg)
                                        transhipentMode = "TRUCK"
                                        return null; // Skip unnecessary TRUCK transshipments
                                    }else if(leg.transportMode === "INTERMODAL" && leg.fromPoint.location.name === leg.toPoint.location.name){
                                        transhipentMode = "INTERMODAL"
                                        return null; // Skip unnecessary INTERMODAL transshipments
                                    }else if(leg.transportMode === "MULTIMODAL" && leg.fromPoint.location.name === leg.toPoint.location.name){
                                        transhipentMode = "MULTIMODAL"
                                        return null; // Skip unnecessary INTERMODAL transshipments
                                    }else if(!leg.transportMode || leg.transportMode === "---"){
                                        try {
                                            transhipentMode = await classifyScheduleTransportMode(leg);
                                            //console.log("-- .... ---transport mode of other legs--- .... ---", transportMode)
                                        } catch {
                                            transportMode = "Unknown";
                                        }
                                    }

                                    return {
                                        unlocode: transshipPort?.unlocode,
                                        port_of_transshipment_name: transshipPort?.name,
                                        port_of_transshipment_id: transshipPortId,
                                        etd: nextLeg?.fromPoint?.etd?.substring(0, 10),
                                        //etd: nextLeg?.fromPoint?.etd,
                                        eta: leg?.toPoint?.eta?.substring(0, 10),
                                        vessel: leg?.vessel?.name,
                                        //vessel: leg?.vessel?.name && leg?.vessel?.name !== "---" ? leg?.vessel?.name : uuidv4(),
                                        vesselCode: leg?.vessel?.code,
                                        route: leg?.service?.name,
                                        //route: leg?.service?.name && leg?.service?.name !== "---" ? leg?.service?.name : uuidv4(),
                                        serviceCode: leg?.service?.code,
                                        voyage: leg?.externalVoyageNumber,
                                        //voyage: leg?.externalVoyageNumber && leg?.externalVoyageNumber !== "---" ? leg?.externalVoyageNumber : uuidv4(),
                                        country: getCountryName(transshipPort?.unlocode),
                                        //transportMode: "Sea",
                                        transportMode: 
                                        ((transhipentMode === "VESSEL" || transhipentMode === "FEEDER" || transhipentMode === "BARGE") ? "Sea" 
                                        : (transhipentMode === "TRUCK" ? "Truck" : ((transhipentMode === "RAIL" ? "Rail" 
                                        : (transhipentMode === "INTERMODAL" ? "Intermodal" : (transhipentMode === "MULTIMODAL" ? "Multimodal" : null)))))),
                                    };
                                })
                            )).filter(Boolean); // This removes any undefined or null values
              }

              // Return a single schedule object
              return schedule;
            })
          );

          // 4) Store the array of schedules for this "carrier + week" key
          carrierWeekMap[combinedKey] = schedulesForWeek;
        }

        // 5) Return the map for this routeGroup.
        // Something like: { "COSU Week 1": [...], "COSU Week 2": [...], ... }
        return carrierWeekMap;
      })
    );


    // 6) Merge them into one final object
    const finalCarrierWeekMap = Object.assign({}, ...results);
 
    return finalCarrierWeekMap;
  };
